export class Api {
  headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }

  async request(url, body) {
    const options = {
      headers: this.headers,
      method: 'POST',
      body: JSON.stringify(body)
    }
    const response = await fetch(url, options)
    const data = await response.json()
    if (response.ok) {
      return data
    } else {
      throw data
    }
  }

  async submit(data) {
    const body = {...data}
    try {
      return await this.request('api/v1/auth/signup', body)
    } catch (e) {
      throw e
    }
  }

  async freeTrialRequest(data) {
    const body = {...data}
    try {
      return await this.request('api/v1/auth/signup-custom', body)
    } catch (e) {
      throw e
    }
  }
}
